import { Loadable } from 'components/common';
import { OmniHistoriesProvider } from 'contexts';
import React from 'react';
import { colorsBase } from 'themes';
import { ChatSessionDto } from 'types';
import OmniChannelChatHistoriesChat from './OmniChannelChatHistoriesChat';

type Props = {
  chatSession: ChatSessionDto;
};
const OmniChannelChatHistoriesChatBox: React.FC<Props> = ({ chatSession }) => {
  return (
    <Loadable>
      <OmniHistoriesProvider
        isRead={false}
        endpointName={'history-chat-sessions'}
        chatSession={chatSession}
        variables={{
          systemMessText: '#ffff'
        }}
        isShowName={false}
      >
        <OmniChannelChatHistoriesChat />
      </OmniHistoriesProvider>
    </Loadable>
  );
};
export default OmniChannelChatHistoriesChatBox;
